<template lang="pug">
div
	.position-relative
		section.section.section-lg.section-hero.heroPlastomex
			div(style='height: fit-content')
				h1.h-titulo Esquineros
				p.lead.h-subtitulo
	
	section.section.section-lg.pt-lg-0.mt--100
	.container
			h2.sublinea-centro Estandar
			.row.justify-content-center
				.col-10.col-lg-6.my-3(v-for='e in esquineros')
					.card.card-lift--hover.shadow.border-0.text-center(@click="show_modalE(e)")
						picture
							source(:srcset='webp(e.img)' type="image/webp" )
							img.card-img-top(:src='e.img', alt='Card image cap')
						
						.card-body.px-0
							h6.text-primary.display-4.text-uppercase
								span 
								|  {{e.titulo}}
							//-button.btn.btn-primary.btn-sm.ml-0(@click="show_modalE(e)") Especificaciones


	b-modal(v-model='modalE' size="lg" lazy )
		h6#modal-title-default.modal-title(slot='header') 
		.modal-body.especificaciones(v-if="modalE")
			h4.titulo-producto {{seleccionada.titulo}}
			picture
				source(:srcset='webp(seleccionada.img)' type="image/webp" )
				img.card-img-top(:src='seleccionada.img', alt='Card image cap')
			.row.justify-content-center
				.col-sm-6.text-left
					ul
						li
							//-svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M9,11H15V8L19,12L15,16V13H9V16L5,12L9,8V11M2,20V4H4V20H2M20,20V4H22V20H20Z')
							| Acabado: 
							span#anchoI {{seleccionada.acabado}}
						li
							//-svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M13,9V15H16L12,19L8,15H11V9H8L12,5L16,9H13M4,2H20V4H4V2M4,20H20V22H4V20Z')
							| Color: 
							span#altofI {{seleccionada.color}}
						li
							//-svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M13,9V15H16L12,19L8,15H11V9H8L12,5L16,9H13M4,2H20V4H4V2M4,20H20V22H4V20Z')
							| Longitudes: 
							ul
								li(v-for='long in seleccionada.longitudes')
									span  {{ long }} 
						//-li
							svg(style='width:24px;height:24px', viewBox='0 0 24 24')
								path(fill='#000000', d='M13,9V15H16L12,19L8,15H11V9H8L12,5L16,9H13M4,2H20V4H4V2M4,20H20V22H4V20Z')
							| Peso: 
							span#altofI {{}}	
						li
							| Características: 
							ul
								li(v-for='ca in seleccionada.caracteristicas')
									span  {{ca}} 
				.col-sm-6
					h5 Aplicaciones: 
					ul
						li
							p {{ seleccionada.aplicaciones }}


		template(slot='modal-footer')
			router-link.btn.btn-primary(to="/contacto#contacto") Cotizar
			base-button.ml-auto(type='secondary', @click="modalE = false") X

</template>

<script>
export default {
	data() {
		return {
			esquineros: [],
			seleccionada: {},
			modalE: false
		};
	},
	methods: {
		show_modalE: function(esq) {
			this.seleccionada = esq;
			this.modalE = true;
		},
		webp(i) {
			if (!!i) return `${i.split(".")[1]}.webp`;
		}
	},
	created() {
		fetch("/data/esquineros.json")
			.then(response => response.json())
			.then(data => (this.esquineros = data))
			.catch(err => console.error(err));
	}
};
</script>

<style lang="scss" scoped>
.heroPlastomex {
	background-image: url("/img/optimizadas/ESQUINEROS.jpg");
}
.webp .heroPlastomex {
	background-image: url("/img/optimizadas/ESQUINEROS.webp");
}
</style>